import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=12bf4590&scoped=true"
import script from "./Cards.vue?vue&type=script&lang=ts"
export * from "./Cards.vue?vue&type=script&lang=ts"
import style0 from "./Cards.vue?vue&type=style&index=0&id=12bf4590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bf4590",
  null
  
)

export default component.exports